import { render, staticRenderFns } from "./ItemCardButton.vue?vue&type=template&id=ff87e084"
import script from "./ItemCardButton.vue?vue&type=script&lang=js"
export * from "./ItemCardButton.vue?vue&type=script&lang=js"
import style0 from "./ItemCardButton.vue?vue&type=style&index=0&id=ff87e084&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports